// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- experiments are intentionally merged at runtime from ExperimentsSymbol (authoritative IoC value) with platformAppsExperiments from siteConfig, mirroring the environmentService pattern.
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider, Experiments } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { IExperimentsDefinition } from '@wix/site-service-experiments/definition'
import { ExperimentsDefinition as definition } from '@wix/site-service-experiments/definition'
import { ExperimentsService as impl } from '@wix/site-service-experiments/implementations'
import type { ExperimentsServiceSiteConfig } from '@wix/viewer-services-configs/configs'
import { name } from './symbols'

export type SiteExperimentsServiceSiteConfig = ExperimentsServiceSiteConfig

export const SiteExperimentsService: FactoryWithDependencies<ServiceProvider<IExperimentsDefinition, typeof impl>> =
	withDependencies(
		[named(SiteFeatureConfigSymbol, name), ExperimentsSymbol],
		(
			siteConfig: SiteExperimentsServiceSiteConfig,
			experiments: Experiments
		): ServiceProvider<IExperimentsDefinition, typeof impl> => {
			const flatAppExperiments = Object.values(siteConfig.platformAppsExperiments ?? {}).reduce(
				(acc, appExps) => ({ ...acc, ...appExps }),
				{} as Record<string, string>
			)
			const config = { experiments: { ...flatAppExperiments, ...experiments } }
			return {
				definition,
				impl,
				config,
				platformConfig: config,
			}
		}
	)
